<template>
  <div class="main-header" style="margin: 0; display: initial">
    <div style="margin: 0">
      <a :href="homeUrl">
        <img
          class="main-logo"
          :src="logo"
          alt="Logo Aliança"
        />
      </a>
      <div class="etapas-progresso">
        <div class="etapas-progresso-texto">
          <span
            id="globaletapa1"
            @click="voltarSimuleAqui()"
            style="cursor: pointer"
          >
            <img src="../assets/fase-1.svg" alt="Fase 1" />
            <span
              class="rounded-destaque"
              style="margin-right: 18px; margin-left: -15px; margin-top: 10px"
            ></span>
            1. Simular plano para você</span
          >
          <span id="globaletapa2" class="etapas-progresso-texto-disabled"
            ><img src="../assets/fase-2.svg" alt="Fase 2" />
            <span
              class="rounded-destaque"
              style="margin-right: 18px; margin-left: -10px; margin-top: 10px"
            ></span>
            2. Comparar planos</span
          >
          <span id="globaletapa3" class="etapas-progresso-texto-disabled"
            ><img src="../assets/fase-3.svg" alt="Fase 3" />
            <span
              class="rounded-destaque"
              style="margin-right: 18px; margin-left: -10px; margin-top: 10px"
            ></span>
            3. Comprar</span
          >
          <span id="globaletapa4" class="etapas-progresso-texto-disabled"
            ><img src="../assets/fase-4.svg" alt="Fase 4" />
            <span
              class="rounded-destaque"
              style="margin-right: 18px; margin-left: -10px; margin-top: 10px"
            ></span>
            4. Preencher documentação</span
          >
        </div>
        <span v-for="(etapa, index) in etapas" :key="index">
          <div
            :id="'globaletapam' + (index + 1)"
            class="etapas-progresso-texto etapas-progresso-mobile"
            style="display: none"
          >
            <span
              ><img
                :src="require('@/assets/fase-' + (index + 1) + '.svg')"
                :alt="'Fase ' + (index + 1)"
              />
              <span
                class="rounded-destaque"
                style="margin-right: 18px; margin-left: -15px; margin-top: 10px"
              ></span>
              {{ index + 1 }}. {{ etapa.label }}</span
            >
          </div>
          <div
            :id="'globaletapaprox' + (index + 1)"
            class="etapas-progresso-texto div-proximo-etapa-mobile"
            style="display: none"
          >
            <i class="proximo-etapa-progresso">Próximo: {{ etapa.proximo }}</i>
          </div>
        </span>
        <div class="barra-progress">
          <progress id="step-progress" value="0" max="100"></progress>
          <span id="step-progress-point1" class="rounded-point-progress"></span>
          <span
            id="step-progress-point2"
            class="rounded-point-progress"
            style="margin-left: calc((100% / 3) * 1)"
          ></span>
          <span
            id="step-progress-point3"
            class="rounded-point-progress"
            style="margin-left: calc((100% / 3) * 2)"
          ></span>
          <span
            id="step-progress-point4"
            class="rounded-point-progress"
            style="margin-left: calc((100% / 3) * 3)"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .main-logo {
    height: 100px;
    width:  auto;
  }
</style>

<script>
import store from "../store";

export default {
  data() {
    return {
      etapas: [
        { label: "Simular plano", proximo: "Comparar" },
        { label: "Comparar planos", proximo: "Comprar" },
        { label: "Comprar", proximo: "Documentação" },
        { label: "Documentação", proximo: "Ultimo passo" },
      ],
      homeUrl: null
    };
  },
  created() {
    this.homeUrl = process.env.VUE_APP_ALIANCA_HOME
  },
  computed: {
    logo(){
      return store.getters.getAliancaLogo;
    }
  },
  methods: {
    voltarSimuleAqui() {
      let fasesimulacao = store.getters.getAliancaProxEtapa;
      console.log("Fase simulacao:", fasesimulacao);
      if (fasesimulacao == "end") {
        store.commit("mutAliancaProxEtapa", "step-5");
        this.$router.push("simule-aqui");
        document.getElementById("step-progress").value = 6.67 * 4 + 3;
        document
          .getElementById("step-progress-point2")
          .classList.remove("rounded-point-progress-ok");
      }
    },
    voltarStepUm() {
      store.commit("mutAliancaProxEtapa", "step-1");

      document.getElementById("step-progress").value = 6.67 * 4 + 3;
      document
        .getElementById("step-progress-point2")
        .classList.remove("rounded-point-progress-ok");
    },
  },
};
</script>
